import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.FormReferenceSelect,
  title: 'Reference Select',
  category: ComponentCategory.FormControls,
};
